import React from "react";
import { Col, Container, Row} from "react-bootstrap";

class DailyOrderList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            orderList:props.orderList
        };
    }

    render() {
        let response = "";
        if (this.state.orderList === null || this.state.orderList.length === 0){
            response = <div>No Orders Found</div>
        }else{
            let orderRows = [];
            for(let i =0; i < this.state.orderList.length; i++) {

                let order = this.state.orderList[i];
                let theDae = new Date(order['3_date']);
                orderRows.push(<Row key={i}>
                    <Col>{order['1_orderId']}</Col>
                    <Col>{order['2_action']}</Col>
                    <Col>{theDae.toLocaleTimeString("en-US")}</Col>
                    <Col>{order['4_type']}</Col>
                    <Col>{order['5_avgFill']}</Col>
                    <Col>{order['6_status']}</Col>
                    <Col>{order['7_unitsFilled']}</Col>
                </Row>);
            }
            response =<div className="press-grid">
                <Container>
                    <Row>
                        <Col>Order Id</Col>
                        <Col>Action</Col>
                        <Col>Date</Col>
                        <Col>Type</Col>
                        <Col>Avg Fill</Col>
                        <Col>Status</Col>
                        <Col>Units</Col>
                    </Row>
                    {orderRows}
                </Container>
            </div>
        }
        return response;
    }
}


export {DailyOrderList}
